<app-nav [navItems]="navItems" />

<div class="container">
  <div class="account">
    <app-account-menu />
    <div class="account__dashboard">
      <router-outlet />
      <app-account-profile-block-page />
    </div>
  </div>
</div>
